import qs from "qs";

export default {
    param() {
        let h5Login = localStorage.getItem("INVERTADVISER_H5_LOGIN")
        h5Login && (h5Login = JSON.parse(h5Login))
        const { token, memberId } = h5Login || {};
        return {
            source: 'H5',
            token: token || '',
            memberId: memberId || '',
        }
    },
    linkSearch(param) {
        return `${qs.stringify({ ...this.param(), ...param })}`
    },
    isLogin() {
        if (this.param().token) {
            return Promise.resolve(true)
        } else {
            return Promise.reject(false)
        }
    },
    goToLogin() {
        location.hash = `#/login?from=${location.hash.replace('#/', '')}`;
    }
}